<template lang="pug">
  card-power-ball
    v-row(justify="center")
      v-col(cols=12 align="center" v-if="closedAt").pb-0
        h3.white--text.font-weight-power-ball {{ $t('next-resut-date', { date: dateFormatDisplay(closedAt) }) }} 

      v-col(cols=12 align="center").pb-0
        h3.white--text.font-weight-power-ball {{ $t('count-down-result') }} 
      v-col(cols=12 align="center")
        v-row(justify="center")
          v-card(style="border-radius:12px; padding-right: min(7vw, 100px); padding-left: min(7vw, 100px);") 
            v-row(justify="center" v-if="openStatus && !lockStatus")
              v-col(cols="auto").py-0
                h1.font-fifth-v2 {{ timeCountDown.split(':')[0] || '' }}
              v-col(cols="auto" style="padding-left:0; padding-right:0;").py-0
                h1.font-fifth-v2 :
              v-col(cols="auto").py-0
                h1.font-fifth-v2 {{ timeCountDown.split(':')[1] || '' }}
              v-col(cols="auto" style="padding-left:0; padding-right:0;").py-0
                h1.font-fifth-v2 :
              v-col(cols="auto").py-0
                h1.font-fifth-v2 {{ timeCountDown.split(':')[2] || '' }}
            v-row(justify="center" v-else)
              h1.font-fifth-v2(style="font-size: min(5vw,30px)") {{ timeCountDown }}
        v-row(justify="center")
          v-col(cols="auto").mx-2
            h5.white--text.font-weight-power-ball {{ $t('unit.hours') }}
          v-col(cols="auto").mx-2
            h5.white--text.font-weight-power-ball {{ $t('unit.minute') }}
          v-col(cols="auto").mx-2
            h5.white--text.font-weight-power-ball {{ $t('unit.second') }}

</template>
<script>
import CardPowerBall from './CardBasePowerBall.vue'
import { getTime, timeRemain, timeStampConvert } from '@/plugins/time'
import { COUNTDOWNONESEC } from '@/const/setTimeOutConfig'
import { ROUTE_POWER_BALL } from '@/const/route'
import { dateFormatDisplay } from '@/plugins/time'
export default {
  components: {
    CardPowerBall
  },
  props: {
    closedAt: {
      type: String,
      default: null
    },
    lockedAt: {
      type: String,
      default: null
    },
    openedAt: {
      type: String,
      default: null
    },
  },
  data: () => ({
    timeCountDown: null,
    openStatus: false,
    lockStatus: true,
    closeStatus: false,
    openedTimestamp: null,
    lockedTimestamp: null,
    closedTimestamp: null,
  }),
  watch: {
    openStatus (val) {
      this.$emit('setOpenStatus', val)
    },
    openedAt () {
      this.load()
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    dateFormatDisplay,
    load () {
      if(!this.openedAt) return
      this.openedTimestamp = timeStampConvert(this.openedAt) + 100000
      this.lockedTimestamp= timeStampConvert(this.lockedAt)
      this.closedTimestamp = timeStampConvert(this.closedAt)
      
      if(timeRemain(this.lockedTimestamp) < 0){
        this.timeCountDown = this.$t('closed-stake')
        this.closeStatus = timeRemain(this.closedTimestamp) > 0 ? false : true
      } else {
        this.timeCountDown = getTime(timeRemain(this.lockedTimestamp))
        this.openStatus = true
        this.lockStatus = false
        this.closeStatus = false
      }
      if(!this.closeStatus) this.countDownTimer()
    },
    countDownTimer () {
      if(timeRemain(this.closedTimestamp) > 0 && this.$route.name === ROUTE_POWER_BALL) {
        setTimeout(() => { 
          if(timeRemain(this.openedTimestamp)>0){
            this.timeCountDown = this.$t('coming-soon')
            this.openStatus = false
          } else if(timeRemain(this.lockedTimestamp) >0) {
            this.timeCountDown = getTime(timeRemain(this.lockedTimestamp))
            this.openStatus = true
          } else { 
            this.timeCountDown = this.$t('closed-stake')
            this.lockStatus = true
            this.openStatus = false
          }
          this.countDownTimer()
        }, COUNTDOWNONESEC)
      }
    }
  }
}
</script>